import { useMutation } from "@tanstack/react-query";
import { post } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";
import { useError } from "hooks/use-error";
import queryClient from "query-client";
import { BookingMenu } from "types/menu";
import { error as logError } from "logger/logger";

export const useBookingMenuRespond = () => {
    const { setErrorCode, openReservationFailedModal } = useError();
    const id = useBookingId();

    const updateBookingMenu = async (bookingMenu: BookingMenu) => {
        let menu: BookingMenu[] = [];

        try {
            menu = await post<BookingMenu[], BookingMenu[]>(
                "BookingMenu/BookingMenusExternal/Respond",
                [bookingMenu]
            );
            await queryClient.invalidateQueries({
                queryKey: ["booking", id],
            });
        } catch (error) {
            const response = (error as { response?: { data?: { code: number } } })?.response?.data;
            logError(error);
            const errorCode = response?.code;
            if (typeof errorCode === "number") {
                setErrorCode(errorCode);
                openReservationFailedModal();
            }
        }

        return menu;
    };

    return useMutation({
        mutationFn: updateBookingMenu,
        scope: {
            id: "webbooking-create",
        },
    });
};
